import styled, { css, StyledComponent } from 'styled-components';

export const AttributeContainer: StyledComponent<
  'div',
  any,
  { active?: boolean | undefined },
  never
> = styled.div<{ active?: boolean }>`
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);

  ${({ active = false }) => {
    if (active) {
      return css`
        border-color: #0046ff;
      `;
    }
    return;
  }}
`;

export const EventName = styled.div`
  display: flex;
  padding: 0 12px 0 16px;
  align-items: center;
  /* gap: 8px; */

  height: 44px;

  background: #f6f6f6;
  color: rgba(0, 0, 0, 0.88);
  /* border-radius: 4px 4px 0 0; */

  /* .emp-ant-select-single.emp-ant-select-show-arrow .emp-ant-select-selection-item {
    padding-inline-end: 95px;
  } */
`;

export const AttributeDescription = styled.div`
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  padding: 12px 0;
`;

export const EventNamesContainer = styled.div`
  display: flex;
  align-items: self-start;
  gap: 16px;
`;

export const RulesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;
